import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../shared/services/dashboard.service';
import { Router } from '@angular/router';
import { EmitterService } from '../shared/services/event-service';
import { DataSharedService } from '../shared/services/data-shared.service';

interface FavoriteDevice {
  device_id: string;
  location: string;
  device_type: string;
  [key: string]: any;
}

interface FavoriteDeviceGroup {
  device_type: string;
  devices: FavoriteDevice[];
}

@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss']
})
export class FavoriteComponent implements OnInit {

  public favorite_devices: FavoriteDeviceGroup[] = [];
  public action: string = '';

  constructor(
    private dashboardService: DashboardService,
    private dataShared: DataSharedService,
    private router: Router,
    private eventEmitter: EmitterService,
  ) { }

  ngOnInit(): void {
    this.getFavoriteDevices();
  }

  getBody() {
    let body = {
      "action": this.action,
      "account_id": localStorage.getItem('account'),
      "favorite": true,
      "user_id": localStorage.getItem('user')
    }

    return body;
  }

  getFavoriteDevices() {
    this.action = 'getFavDevicesByAccount';
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      if (res.status == 200 && res.data) {
        this.favorite_devices = Object.keys(res.data).map((device_type: string) => ({
          device_type: device_type,
          devices: res.data[device_type]
        }));
      }
    })

  }

  getMetricKeys(device: FavoriteDevice): string[] {
    return Object.keys(device).filter((key: string) =>
      key !== 'device_id' &&
      key !== 'location' &&
      key !== 'device_type' &&
      key !== '@timestamp'
    );
  }

  gotoDevice(device: string) {
    this.dataShared.device_id = device;
    this.eventEmitter.emit('menuFromPanelControl', false);
    this.dataShared.curr_menu = 'dashboard~single';
    this.eventEmitter.emit('selectedDevice', device);
    this.router.navigate(['/dashboard/single']);
  }

  toggleFavorite(device_id: string) {
    let body = {
      'action': 'updateDeviceById',
      'account_id': localStorage.getItem('account'),
      'device_id': device_id,
      'data': { 'favorite': 0 }
    }
    this.dashboardService.httpPost(body).subscribe((res: any) => {
      if (res.status === 200) this.getFavoriteDevices();
    });
  }
}